<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal="true"
    top="17vh"
    width="500px"
    :append-to-body="true"
    custom-class="custom-dialog"
  >
    <h3 slot="title" class="title mb10 bottom-line">
      客户特殊要求<span class="common-tips">（系统会在相应的流程阶段提醒，以防出错）</span>
    </h3>
    <div class="display-flex mb10">
      <span class="keep-all">特殊要求:</span>
      <el-input
        v-model="copyProject.特殊要求寻访"
        type="textarea"
        :rows="6"
        :placeholder="`例如：1、某些企业的人不能推荐；`"
      >
      </el-input>
    </div>
    <div class="display-flex mb10">
      <span class="keep-all">推荐要求：</span>
      <el-input
        v-model="copyProject.推荐备注"
        type="textarea"
        :rows="6"
        :placeholder="
          `例如：
1、推荐人选的期望薪资写在邮件正文，不能写在推荐报告；
2、推荐报告特殊模板；
3、简历推荐除了邮件之后要上系统，系统地址：http://www.wertyu.com.cn`
        "
      >
      </el-input>
    </div>
    <div class="display-flex mb10">
      <span class="keep-all">面试安排：</span>
      <el-input
        v-model="copyProject.面试安排"
        type="textarea"
        :rows="6"
        :placeholder="
          `例如：
1、人选面试的时候要带身份证，公司楼下有门禁；
2、面试安排要抄送人力加上业务领导；`
        "
      >
      </el-input>
    </div>
    <div class="bottom-line"></div>
    <div>
      <a> 附件<i class="el-icon-circle-plus" @click="beforeUpload" /> </a>
      <div class="propject_detail_info_table">
        <div class="flex-row project_table_thead">
          <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 propject_detail_info_label"
            >类型</span
          >
          <span
            class="propject_detail_info_table_cell propject_detail_info_files_cell_1 propject_detail_info_label col-1"
            >文件名</span
          >
          <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 propject_detail_info_label"
            >上传时间</span
          >
          <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 propject_detail_info_label"
            >上传人</span
          >
          <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 propject_detail_info_label"
            >操作</span
          >
        </div>
        <div
          v-for="(value, i) in copyProject.files"
          :key="i"
          :class="`flex-row item-center ${i % 2 === 0 ? 'bg-gray' : ''}`"
        >
          <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 col-0">
            {{ value.type }}
          </span>
          <a
            class="propject_detail_info_table_cell propject_detail_info_files_cell_1 col-1"
            @click="previewFile(value)"
            >{{ value.originalname }}</a
          >
          <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 col-0">
            {{ value.createdAt ? dateFormat(new Date(parseInt(value.createdAt, 10)), 'yyyy-mm-dd') : '--' }}
          </span>
          <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 col-0">
            {{ showUploader(value.uploader) }}
          </span>
          <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 col-0">
            <a v-if="userInservice" class="mr5" @click="download(value)">下载</a>
            <a v-if="userInservice" class="ft-danger" @click="removeProjectFile(value)">删除</a>
          </span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <span class="mr10"> <el-button size="mini" type="danger" @click="close">取 消</el-button> </span>
      <el-button size="mini" type="primary" @click="close">确 定</el-button>
    </span>

    <!-- 选择附件类型 -->
    <el-dialog title="附件上传" :close-on-click-modal="false" :visible.sync="selectDialogVisible" :modal="false">
      <div>
        <el-select v-model="fileType" filterable size="mini" placeholder="请选择文件类型">
          <el-option v-for="item in projectFileTypes" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="mr10">
          <el-button size="mini" type="danger" @click="selectDialogVisible = false">取 消</el-button>
        </span>
        <el-button size="mini" type="primary" @click="upload()">下一步</el-button>
      </span>
    </el-dialog>
    <UploadDialog ref="upload" :on-success="uploadSuccess" :type="fileType" :label="fileType" />
  </el-dialog>
</template>
<script>
import { projectFileTypes } from '../../constant/type'
import { download } from '../../constant/utils'

const dateFormat = require('dateformat')

export default {
  props: {
    project: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      dialogVisible: false,
      selectDialogVisible: false,
      fileType: '',
      copyProject: {},
      // 是否在职，在职true
      userInservice: true,
    }
  },
  computed: {
    projectFileTypes() {
      return projectFileTypes
    },
    dateFormat() {
      return dateFormat
    },
    download() {
      return download
    },
  },
  watch: {
    project: {
      handler(newValue, oldValue) {
        this.copyProject = newValue
        if (!this.copyProject.面试安排) this.$set(this.copyProject, '面试安排', '')
        if (!this.copyProject.客户特殊要求) this.$set(this.copyProject, '客户特殊要求', '')
        if (!this.copyProject.特殊要求寻访) this.$set(this.copyProject, '特殊要求寻访', '')
      },
      immediate: true,
    },
  },
  mounted() {
    this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
  },
  methods: {
    async open() {
      this.dialogVisible = true
      this.getProjectFiles(this.copyProject._id)
      this.getCompany()
    },
    async getCompany() {
      const { result } = await app.service('company').getCompany({ 简称: this.copyProject.客户公司 })
      this.copyProject.面试安排 = result.面试安排
      this.copyProject.客户特殊要求 = result.特殊要求
      this.copyProject.特殊要求寻访 = result.用人偏好备注
    },
    close() {
      this.dialogVisible = false
    },
    showUploader(uploader) {
      return Array.isArray(uploader) ? uploader.join('；') : uploader
    },
    beforeUpload() {
      this.selectDialogVisible = true
      this.fileType = ''
    },
    upload() {
      this.$refs.upload.visible(true)
      this.selectDialogVisible = false
    },
    async uploadSuccess(response, file, fileList) {
      this.$refs.upload.visible()
      const res = response[0]
      const projectId = this.copyProject._id
      const type = this.fileType
      try {
        await window.app.service('project').insertProjectFile([
          Object.assign(response[0], {
            type,
            projectId,
          }),
        ])
        this.getProjectFiles(projectId)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async removeProjectFile(file) {
      try {
        await app
          .service('project')
          .removeOssAttachment({ idField: 'projectId', file: { md5: file.md5 }, id: this.copyProject._id })
        this.getProjectFiles(this.copyProject._id)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async getProjectFiles(projectId) {
      if (!projectId) return (this.files = [])
      if (this.filesLoading) return
      this.filesLoading = true
      try {
        const { data } = await app.service('file').projectFiles({ query: { projectId } })
        this.$set(this.copyProject, 'files', data)
      } catch (e) {
        console.error(e)
      }
      this.filesLoading = false
    },
    async previewFile(file) {
      const ref = window.app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
  },
}
</script>
<style scoped>
.display-flex {
  display: flex;
}
.keep-all {
  word-break: keep-all;
  min-width: 70px;
}

.confirm-btn-box {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.confirm-btn-box span {
  font-size: 12px;
}
.common-tips {
  font-size: 12px;
  color: #ff6600;
  margin: 5px 0;
}
.bottom-line::after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #c5c5c5;
  margin-top: 15px;
  margin-bottom: 10px;
}
</style>
